import React, { useState } from "react";
import { InputAdornment, IconButton, DialogActions } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import { Formik, FieldArray } from "formik";
import * as yup from "yup";
import { Table } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Accordion, AccordionTab } from "primereact/accordion";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
  FormSelectField,
  FormTextField,
} from "../../../../../partials/content/Forms/FormField";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import Swal from "sweetalert2";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import Illustration from "../../../../../partials/content/Illustration";
import SearchOperation from "../../operations/searchOperation";
import SearchUser from "../../../users/users/searchUser";
import {
  getItemsReservation,
  saveReservationItemsPickup,
} from "../../../../../services/inventory/itemReservationService";
import SearchJourney from "../../../crm/journey/searchJourney";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import SearchProductionOrder from "../../../production/production-order/SearchProductionOrder";
const itemsPickFormSchema = yup.object().shape({
  docRef: yup.string(),
  operationTitle: yup.string().when("docRef", {
    is: (value) => value === "1",
    then: yup.string().required("Operation Title is required"),
  }),
  journeyTitle: yup.string().when("docRef", {
    is: (value) => value === "2",
    then: yup.string().required("Journey Title is required"),
  }),
  pickedByUserName: yup.string().required("Pickup By is required"),
  itemsReservation: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      itemID: yup.number(),
      varCode: yup.string(),
      qty: yup.number(),
      batchID: yup.number(),
      uomID: yup.number(),
      uomName: yup.string(),
    })
  ),
});
function ReservationItemsPickup({
  warehouseID = 0,
  onConfirmSave,
  onCloseDialog,
}) {
  const [openSearchOp, setOpenSearchOp] = useState(false);
  const [openSearchJourney, setOpenSearchJourney] = useState(false);
  const [openSearchProdOrder, setOpenSearchProdOrder] = useState(false);
  const [openSearchUser, setOpenSearchUser] = useState(false);
  //const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [itemsPick, setItemsPick] = useState({
    docRef: "1",
    salesOrderID: 0,
    salesOrderCode: "",
    operationCardID: 0,
    productionOrderID: 0,
    plantName: "",
    prodItemName: "",
    prodQty: 0,
    prodUom: "",
    journeyID: 0,
    pickedByUserID: 0,
    pickedByUserName: "",
    operationTitle: "",
    journeyTitle: "",
    customerName: "",
    itemsReservation: [],
  });

  return (
    <Formik
      initialValues={itemsPick}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={itemsPickFormSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Items Reservation Pickup ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveReservationItemsPickup(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        dirty,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-window-maximize"></i>
                  <span>
                    <strong>Items Pickup Header</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormSelectField
                        label="Document Reference"
                        name="docRef"
                        onSelectChange={(value) => {
                          setFieldValue("itemsReservation", []);
                        }}
                        options={[
                          { value: "1", label: "Operation" },
                          { value: "2", label: "Sales Journey" },
                          { value: "3", label: "Production Order" },
                        ]}
                      />
                      {values.docRef === "1" ? (
                        <FormTextField
                          label="Operation Name"
                          name="operationTitle"
                          searchButton
                          readonly
                          onSearchClick={() => {
                            setOpenSearchOp(true);
                          }}
                        />
                      ) : values.docRef === "2" ? (
                        <FormTextField
                          label="Sales Journey Name"
                          name="journeyTitle"
                          searchButton
                          readonly
                          onSearchClick={() => {
                            setOpenSearchJourney(true);
                          }}
                        />
                      ) : values.docRef === "3" ? (
                        <React.Fragment>
                          <FormTextField
                            label="Production"
                            name="prodItemName"
                            searchButton
                            readonly
                            onSearchClick={() => {
                              setOpenSearchProdOrder(true);
                            }}
                          />
                          <FormTextField
                            label="Production ID"
                            name="productionOrderID"
                            readonly
                            onSearchClick={() => {
                              setOpenSearchProdOrder(true);
                            }}
                          />
                        </React.Fragment>
                      ) : null}
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      {values.docRef === "1" ? (
                        <FormTextField
                          label="Customer Name"
                          name="customerName"
                          readonly
                        />
                      ) : null}
                      <FormTextField
                        label="Picked By"
                        name="pickedByUserName"
                        searchButton
                        readonly
                        onSearchClick={() => {
                          setOpenSearchUser(true);
                        }}
                      />
                      {values.docRef === "3" ? (
                        <React.Fragment>
                          <FormTextField
                            label="Plant"
                            name="plantName"
                            readonly
                          />
                          <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Production Qty"
                                name="prodQty"
                                readonly
                              />
                            </div>
                            <div className="col-sm-6 col-md-6 col-lg-6">
                              <FormTextField
                                label="Production Unit"
                                name="prodUom"
                                readonly
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>
                  {values.docRef === "1" ? (
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-6">
                        <FormTextField
                          label="Sales Order ID"
                          name="salesOrderCode"
                          readonly
                        />
                      </div>
                    </div>
                  ) : null}
                </Card.Body>
              </Card>
            </div>
          </div>
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Pickup Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <FieldArray name="itemsReservation">
                        {({ push, remove }) => (
                          <React.Fragment>
                            <div className="card">
                              <Table borderless size="sm" responsive="xl">
                                {values.itemsReservation &&
                                values.itemsReservation.length > 0 ? (
                                  <thead className="text-center">
                                    <tr>
                                      <th style={{ width: "15%" }}>
                                        Reserve ID
                                      </th>
                                      <th style={{ width: "45%" }}>
                                        Item Name
                                      </th>
                                      <th style={{ width: "10%" }}>Quantity</th>
                                      <th style={{ width: "15%" }}>Unit</th>
                                      <th style={{ width: "15%" }}>Batch ID</th>
                                    </tr>
                                  </thead>
                                ) : null}
                                <tbody>
                                  {values.itemsReservation &&
                                  values.itemsReservation.length > 0 ? (
                                    values.itemsReservation.map(
                                      (item, index) => (
                                        <tr key={index}>
                                          <td>
                                            <FormArrayTextField
                                              arrayPropName="itemsReservation"
                                              index={index}
                                              propName="ID"
                                              margin="none"
                                              readonly
                                            />
                                          </td>
                                          <td>
                                            <FormOutlinedNoMarginTextField
                                              value={`${item.itemCode} ${item.itemName}`}
                                              InputProps={{
                                                startAdornment:
                                                  item.itemType > 0 ? (
                                                    <InputAdornment position="start">
                                                      <BootstrapTooltip
                                                        title={
                                                          item.itemTypeName
                                                        }
                                                      >
                                                        <i
                                                          className={
                                                            item.itemType === 1
                                                              ? "fas fa-boxes text-success"
                                                              : item.itemType ===
                                                                2
                                                              ? "fas fa-tools text-primary"
                                                              : item.itemType ===
                                                                3
                                                              ? "fas fa-building text-info"
                                                              : item.itemType ===
                                                                4
                                                              ? "fas fa-boxes text-warning"
                                                              : item.itemType ===
                                                                5
                                                              ? "fas fa-boxes text-danger"
                                                              : null
                                                          }
                                                        ></i>
                                                      </BootstrapTooltip>
                                                    </InputAdornment>
                                                  ) : null,
                                                readOnly: true,
                                              }}
                                            />
                                          </td>
                                          <td>
                                            <FormArrayTextField
                                              arrayPropName="itemsReservation"
                                              index={index}
                                              propName="qty"
                                              quantityField
                                              margin="none"
                                              readonly
                                            />
                                          </td>
                                          <td>
                                            <FormArrayTextField
                                              arrayPropName="itemsReservation"
                                              index={index}
                                              propName="uomName"
                                              margin="none"
                                              readonly
                                            />
                                          </td>
                                          <td>
                                            <FormArrayTextField
                                              arrayPropName="itemsReservation"
                                              index={index}
                                              propName="batchID"
                                              margin="none"
                                              readonly
                                            />
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        className="text-center py-3"
                                        colSpan="5"
                                      >
                                        <Illustration
                                          imageSource="INVIFO Inventory.png"
                                          guidance="You don't have any Pickup items yet"
                                          guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                          size="sm"
                                        ></Illustration>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </React.Fragment>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Close
            </button>
            {values.itemsReservation.length > 0 ? (
              <button
                type="submit"
                className="btn btn-success btn-md btn-pill btn-bold"
              >
                <i className="fas fa-save"></i>
                Save
              </button>
            ) : null}
          </DialogActions>
          <DialogLayout
            open={openSearchJourney}
            title="Search Sales Journey"
            onCloseDialog={() => {
              setOpenSearchJourney(false);
            }}
            fullScreen={false}
          >
            <SearchJourney
              onSelectJourney={async (journey) => {
                setFieldValue("operationCardID", 0);
                setFieldValue("operationTitle", "");
                setFieldValue("salesOrderID", 0);
                setFieldValue("salesOrderCode", "");
                setFieldValue("customerName", "");

                setFieldValue("journeyTitle", journey.title);
                setFieldValue("journeyID", journey.ID);
                getItemsReservation(0, 0, journey.ID, warehouseID).then(
                  (response) => {
                    const { data } = response.data;
                    setFieldValue("itemsReservation", data.itemsReservation);
                    setOpenSearchJourney(false);
                  }
                );
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchJourney(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchOp}
            title="Search Operation"
            onCloseDialog={() => {
              setOpenSearchOp(false);
            }}
            fullScreen={false}
          >
            <SearchOperation
              warehouseID={warehouseID}
              onSelectOperation={async (operation) => {
                setFieldValue("journeyTitle", "");
                setFieldValue("journeyID", 0);

                setFieldValue("operationCardID", operation.ID);
                setFieldValue("operationTitle", operation.title);
                setFieldValue("salesOrderID", operation.salesOrderID);
                setFieldValue("salesOrderCode", operation.salesOrderCode);
                setFieldValue("customerName", operation.customer.customerName);
                const response = await getItemsReservation(
                  0,
                  operation.ID,
                  0,
                  warehouseID,
                  0,
                  "OPSJ"
                );
                const { data } = response.data;
                setFieldValue("itemsReservation", data.itemsReservation);
                setOpenSearchOp(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchOp(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchProdOrder}
            title="Search Production"
            onCloseDialog={() => {
              setOpenSearchProdOrder(false);
            }}
            fullScreen={false}
          >
            <SearchProductionOrder
              productionOrderID={itemsPick.productionOrderID}
              onSelectProductionOrder={async (productionOrder) => {
                setFieldValue("productionOrderID", productionOrder.ID);
                setFieldValue("plantName", productionOrder.plantName);
                setFieldValue("prodItemName", productionOrder.itemName);
                setFieldValue("prodQty", productionOrder.prodQty);
                setFieldValue("prodUom", productionOrder.uomName);
                const response = await getItemsReservation(
                  0,
                  0,
                  0,
                  warehouseID,
                  0,
                  "",
                  values.productionOrderID
                );
                const { data } = response.data;
                setFieldValue("itemsReservation", data.itemsReservation);
                setOpenSearchProdOrder(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchProdOrder(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchUser}
            title="Search User"
            onCloseDialog={() => {
              setOpenSearchUser(false);
            }}
            maxWIdth="lg"
          >
            <SearchUser
              onSelectUser={(user) => {
                setFieldValue("pickedByUserID", user.ID);
                setFieldValue(
                  "pickedByUserName",
                  user.firstName + " " + user.lastName
                );
                setOpenSearchUser(false);
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  setOpenSearchUser(false);
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );
}

export default ReservationItemsPickup;
